module.exports = __webpack_public_path__ + "img/4.17b5d213.svg";